module.exports = __webpack_public_path__ + "img/new years shrine visit i.c0372db7.png";